let uid = 0

export default function () {
  uid++
  return uid
}



// WEBPACK FOOTER //
// ./src/helpers/generate-uuid.js